﻿// --- START OF FILE Hero.jsx ---

import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Shield, Lightbulb } from 'lucide-react'; // Icons chosen for each stat
import { Button } from '@/components/ui/button';

const Hero = () => {
  const handleLearnMore = () => {
    const element = document.querySelector('#solutions');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const stats = [
    { value: 'Trusted', label: 'Partner', icon: Shield },
    { value: 'Industry', label: 'Expertise', icon: Zap },
    { value: 'Bespoke', label: 'Solutions', icon: Lightbulb },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Glow Effects - Updated colors to new palette */}
      <div className="absolute inset-0 data-grid opacity-20"></div>
      <div className="absolute top-20 left-10 w-20 h-20 bg-[hsl(var(--peacock-blue))]/20 rounded-full blur-xl floating-animation"></div>
      <div className="absolute bottom-20 right-10 w-32 h-32 bg-[hsl(var(--light-gold))]/20 rounded-full blur-xl floating-animation" style={{ animationDelay: '2s' }}></div>
      <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-[hsl(var(--primary-gold))]/20 rounded-full blur-xl floating-animation" style={{ animationDelay: '4s' }}></div>

      <div className="container mx-auto px-6 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-5xl mx-auto"
        >
          {/* Main Headline - gradient-text will display the new pattern from index.css, and now use Oxanium font */}
          <motion.h1
            className="text-5xl md:text-5xl font-bold mb-6 leading-tight"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            <span className="gradient-text">Engineering High-Performance Fintech Solutions</span>
            <br />
          </motion.h1>

          <motion.p
            className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            Building ultra-low latency trading systems, data-driven analytics, and efficient project management to drive financial institutions' market success.
          </motion.p>

          {/* Call-to-Action Button - Updated to primary gold outline */}
          <motion.div
            className="flex justify-center mb-16"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7 }}
          >
            <Button
              onClick={handleLearnMore}
              variant="outline"
              size="lg"
              className="border-2 border-[hsl(var(--primary-gold))] text-[hsl(var(--primary-gold))] hover:bg-[hsl(var(--primary-gold))]/10 px-8 py-4 text-lg font-semibold rounded-lg transition-all duration-300 transform hover:scale-105"
            >
              Learn More
            </Button>
          </motion.div>

          {/* Updated Stats Section - Icons and hover effect */}
          <motion.div
            className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.9 }}
          >
            {stats.map((stat, index) => (
              <motion.div
                key={stat.label}
                className="glass-effect rounded-xl p-6 text-center hover:neon-glow"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 1 + index * 0.1 }}
                whileHover={{ scale: 1.05 }}
              >
                {/* Icons now use primary-gold for a consistent accent in this section */}
                <stat.icon className="w-9 h-9 text-[hsl(var(--primary-gold))] mx-auto mb-3" />
                <div className="text-3xl font-bold gradient-text mb-2">{stat.value}</div> {/* gradient-text already updated */}
                <div className="text-gray-400 font-medium">{stat.label}</div>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>


  );
};

export default Hero;
// --- END OF FILE Hero.jsx ---